<template>
    <div class="container">

        <div class="studio-top d-flex justify-space-between align-center">
            <BackButton/>

            <SimpleInput
                    v-model="searchText"
                    placeholder="Search"
                    :isSearch="true"
                    class="searchInput"
                    @input="searchHandler"
            />
        </div>


        <Table
                :table-head="header"
                :table-body="body"
                :tableData="tableData"
                :isHover="false"
                :request-function="getPartnerStudios"
                more-mode="mobile"
                :options="options"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    // import Table from "@/elements/Table/Table";
    import { getPartnerStudios } from "@/api/studioServices";
    import Table from "@/elements/Table/Table";
    import SimpleInput from "@/elements/SimpleInput";

    export default {
        components: {
            Table,
            SimpleInput,
        },

        data() {
            return {
                getPartnerStudios: getPartnerStudios,
                searchText: '',
            }
        },

        computed: {
            ...mapGetters([
                'tableData',
            ]),


            options() {
                return {
                    searchText: this.searchText,
                }
            },

        header() {
            return [
                {
                    name: 'name',
                    adaptiveMode: 'mobile',
                    width: '200px'

                },
                {
                    name: 'passCode',
                    adaptiveMode: 'tablet',

                },
                {
                    name: 'city',
                    adaptiveMode: 'mobile',
                    width: '140px'

                },

                {
                    name: 'country',
                    adaptiveMode: 'tablet',
                },
                {
                    name: 'url',
                    adaptiveMode: 'none',
                    width: '224px'

                },

                // {
                //     name: 't',
                //     adaptiveMode: 'none',
                //     width: '24px'

                //     width: '24px'
                // },
                // {
                //     name: 'G',
                //     adaptiveMode: 'none',
                //     width: '30px'
                // },

            ]
        },

        body() {
            let arr = [];

            this.tableData.data && this.tableData.data.forEach(item => {
                arr.push({
                    name: item.title,
                    passCode: item.postal_code,
                    city: item.city,
                    country: item.country ? item.country.title : '',
                    url: item.url,
            })
        });

            return arr;
        }
        },

        async created() {
            await this.$store.dispatch('PAGINATE', {page: 1, requestFunction: this.getPartnerStudios, options: this.options });
        },

        methods: {
            async searchHandler() {
                await this.$store.dispatch('PAGINATE', {page: 1, requestFunction: this.getPartnerStudios, options: this.options });
            }
        }
    }
</script>

<style lang="sass" scoped>
.searchInput
    width: 260px
    padding-bottom: 0
    +xs
        width: 100%
        margin-top: 12px
.studio-top
    +xs
        flex-direction: column
        align-items: flex-start!important
        justify-content: flex-start!important
</style>